import IsTouch from './is-touch';

export default function AddClassOnNavWithChildOnMobile($DOM, target, findParent, classes) {
	let is = IsTouch($DOM, classes);

	$DOM.win.on('resize orientationchange', function() {
		let is = IsTouch($DOM, classes);
	});

	$(target).click(function(event) {
		if (!is.Touch) { return; }

		const $item = $(this).parent();

		if ($item.find(findParent).length && !$item.hasClass(classes.Hover)) {
			event.preventDefault();

			$item.toggleClass(classes.Hover).siblings().removeClass(classes.Hover);
		}
	});
}